module.exports = __webpack_public_path__ + "static/img/bg-vip5.52e44b3c.png";